import React, { useEffect } from "react";
import HeroBanner from "./components/hero-banner/HeroBanner";
import InfoCarousel from "./components/info-carousel/InfoCarousel";
import infoItems from "./components/info-carousel/infoData";
import ImageAside from "../../components/image-aside/Image-aside";
import { homeChart, tinyHomeImage } from "../../assets";

const mainText = "Unlock Your Financial Potential"
const mainParagraph = "Discover how One Life Equity Fund can help you achieve your financialgoals."
const buttonText = "Learn More"

export default function Home() {
    return(
        <div className="home">
            <HeroBanner/>
            <InfoCarousel infoItems={infoItems}/>
            <ImageAside mainText={mainText} mainParagraph={mainParagraph} buttonText={buttonText} buttonEventHandler={()=>{}} imageSrc={homeChart} tinyImageSrc={tinyHomeImage}/>
        </div>
    )
}